// src/hooks/useFraccs.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for fraccionamientos management
 * Connects to AppContext for centralized state management
 */
export const useFraccs = () => {
    const { state, actions } = useAppContext();

    // Global state from AppContext
    const fraccs = state.fraccs || [];
    const isLoading = state.loading;
    const error = state.error;

    return {
        // State
        fraccs,
        fraccsCount: fraccs.length,
        isLoading,
        error,
        
        // Actions (maintain same function signatures for backward compatibility)
        fetchFraccs: actions.fetchFraccs,
        addFracc: actions.addFracc,
        updateFracc: actions.updateFracc,
        deleteFracc: actions.deleteFracc,

        // Utility functions
        getFraccById: (id) => {
            return fraccs.find(fracc => fracc.id === id);
        },

        getFraccByName: (name) => {
            return fraccs.find(fracc => fracc.name === name);
        },

        getActiveFraccs: () => {
            return fraccs.filter(fracc => fracc.status !== 'inactive');
        },

        getFraccsByContact: (contact) => {
            return fraccs.filter(fracc => fracc.contact === contact);
        },

        getFraccsByRepresentative: (representative) => {
            return fraccs.filter(fracc => fracc.representative === representative);
        },

        getTotalMaintenanceFee: () => {
            return fraccs.reduce((total, fracc) => total + (fracc.mantenimiento || 0), 0);
        },

        getAverageMaintenanceFee: () => {
            if (fraccs.length === 0) return 0;
            const total = fraccs.reduce((sum, fracc) => sum + (fracc.mantenimiento || 0), 0);
            return total / fraccs.length;
        },

        getFraccWithMostAmenities: () => {
            return fraccs.reduce((prev, current) => {
                const prevCount = prev.amenities ? prev.amenities.length : 0;
                const currentCount = current.amenities ? current.amenities.length : 0;
                return currentCount > prevCount ? current : prev;
            }, fraccs[0] || null);
        },

        getAllAmenities: () => {
            const allAmenities = fraccs.flatMap(fracc => fracc.amenities || []);
            return [...new Set(allAmenities)]; // Remove duplicates
        },

        getFraccsByAmenity: (amenity) => {
            return fraccs.filter(fracc => 
                fracc.amenities?.includes(amenity)
            );
        }
    };
};